import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d5aab2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "home",
  ref: "self"
}
const _hoisted_2 = { class: "home-section intro" }
const _hoisted_3 = { class: "intro-grouped" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "秘塔科技", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "AI赋能专业", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "AI of Professionalism", -1))
const _hoisted_8 = { class: "home-section" }
const _hoisted_9 = { class: "home-section" }
const _hoisted_10 = { class: "home-section" }
const _hoisted_11 = { class: "home-section" }
const _hoisted_12 = { class: "home-section meta-sponsor" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "meta-sponsor-title" }, "秘塔赋能的专业团队", -1))
const _hoisted_14 = { class: "sponsors-container" }
const _hoisted_15 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReactScrollImage = _resolveComponent("ReactScrollImage")!
  const _component_SwipeIntroduce = _resolveComponent("SwipeIntroduce")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ReactScrollImage, {
      class: "main-background-image",
      width: '100%',
      height: '100vh',
      src: require('../assets/images/bg-1.jpg'),
      mode: 'scaleX'
    }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (!_ctx.isMobile())
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, "AI赋能专业 / AI of Professionalism"))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_6,
              _hoisted_7
            ], 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_SwipeIntroduce, {
        mode: 0,
        introduction: {
            title: '秘塔AI搜索',
            profile: '没有广告，直达结果',
            features: [
                '用户问题提供直接、精准的答案，并包含引用源',
                '自动生成大纲、思维导图、相关事件和人物',
                '在数亿篇文献中筛选有用信息，助力学术研究'
            ],
            buttonLinks:{
              experience: 'https://metaso.cn',
            },
            images:[
                require('@/assets/images/ai-search-1.jpg'),
                require('@/assets/images/ai-search-2.jpg'),
                require('@/assets/images/ai-search-3.jpg'),
                require('@/assets/images/ai-search-4.jpg'),
                require('@/assets/images/ai-search-5.jpg'),
            ],
            backgroundImage:require('../assets/images/bg-2.jpg'),
          }
      }, null, 8, ["introduction"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_SwipeIntroduce, {
        mode: 0,
        introduction: {
            title: '秘塔写作猫',
            profile: '一款由AI赋能的写作工具',
            features: [
                '检查字词、标点、语法错误，提供修改建议',
                '针对全文或单句进行改写，提供表达想法的新路径',
                '机器帮助启发灵感，续写下文'
            ],
            buttonLinks:{
              experience: 'http://xiezuocat.com',
              videoIntroduce: 'https://uranus-static.oss-cn-beijing.aliyuncs.com/video/AI%E5%86%99%E4%BD%9C%E4%BB%8B%E7%BB%8D.mp4'
            },
            images:[
                require('@/assets/images/cat1.png'),
                require('@/assets/images/cat2.png'),
                require('@/assets/images/cat3.png'),
                require('@/assets/images/cat4.png'),
            ],
            backgroundImage:require('../assets/images/bg-2.jpg'),
          }
      }, null, 8, ["introduction"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_SwipeIntroduce, {
        mode: 0,
        introduction: {
            title: '秘塔翻译',
            profile: '专业的AI法律翻译',
            features: [
                '语法严谨、用语专业、语意连贯',
                '支持设置术语库',
                '支持各类格式文本，即时获得翻译结果',
                '支持多人在线协作编辑',
                '多重加密手段，保障数据安全'
            ],
            buttonLinks:{
              experience: 'https://fanyi.metaso.cn/#/',
            },
            images:[
                require('@/assets/images/fanyi1.png'),
                require('@/assets/images/fanyi2.png'),
                require('@/assets/images/fanyi3.png')
            ],
            backgroundImage:require('../assets/images/bg-4.jpg'),
          }
      }, null, 8, ["introduction"])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createVNode(_component_SwipeIntroduce, {
        mode: 1,
        crossLeftFrameWidthPercent: 70,
        introduction: {
            title: 'MetaLaw类案分析',
            profile: '精准类案，一键直达',
            features: [
                '区别于传统的法律数据库，无需总结关键词，AI会自动完成自然语言到法言法语的转换',
                '案件分析思路，精准推送类案，全网实时知识经验一键获取',
                '关联问题、思维导图及类案分析报告一键下载'
            ],
            buttonLinks:{
              experience: 'https://meta.law',
            },
            images:[
                {
                  preview: require('@/assets/images/law1.jpg'),
                  review: require('@/assets/images/law1-high.png')
                },
                {
                  preview: require('@/assets/images/law2.jpg'),
                  review: require('@/assets/images/law2-high.png')
                },
                {
                  preview: require('@/assets/images/law3.jpg'),
                  review: require('@/assets/images/law3-high.png')
                },
            ],
            backgroundImage:require('../assets/images/bg-5.jpg'),
          }
      }, null, 8, ["introduction"])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sponsors, (sponsorIcon, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "sponsor-item",
            key: index
          }, [
            sponsorIcon
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "sponsor-item-img",
                  src: sponsorIcon
                }, null, 8, _hoisted_15))
              : _createCommentVNode("", true)
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_Footer)
  ], 512))
}